import React from 'react';
import { SectionContainer, HeadingTitle } from './styled';

function HeadingOnly(props) {
  const { productCategory, itemData } = props;
  return (
    <SectionContainer productcategory={productCategory}>
      <HeadingTitle>{itemData.title}</HeadingTitle>
    </SectionContainer>
  );
}

export default HeadingOnly;
